
    import { VueAgile } from 'vue-agile';

    export default {
        components: {
            agile: VueAgile,
        },
        data() {
            return {
                options: {
                    autoplay: false,
                    navButtons: false,
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                },
                buttonDisabled: false,
            };
        },
        computed: {
            testimonials() {
                return this.$store.state.testimonialData;
            },
        },
        methods: {
            previousSlide() {
                this.debounce();
                this.$refs.testimonialsCarousel.goToPrev();
            },

            nextSlide() {
                this.debounce();
                this.$refs.testimonialsCarousel.goToNext();
            },

            debounce() {
                this.buttonDisabled = true;
                setTimeout(() => {
                    this.buttonDisabled = false;
                }, 500);
            },
        },
    };
